import { render, staticRenderFns } from "./dotation.html?vue&type=template&id=ab1080b8&scoped=true&external"
import script from "./dotation.js?vue&type=script&lang=js&external"
export * from "./dotation.js?vue&type=script&lang=js&external"
import style0 from "./dotation.scss?vue&type=style&index=0&id=ab1080b8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1080b8",
  null
  
)

export default component.exports